import { render } from "./SessionQuestionsEditItemPane.vue?vue&type=template&id=4e7fd498&scoped=true&ts=true"
import script from "./SessionQuestionsEditItemPane.vue?vue&type=script&lang=ts"
export * from "./SessionQuestionsEditItemPane.vue?vue&type=script&lang=ts"

import "./SessionQuestionsEditItemPane.vue?vue&type=style&index=0&id=4e7fd498&scoped=true&lang=css"

import exportComponent from "D:\\Ventla Code\\New Admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e7fd498"]])

export default __exports__